enum AppRoute {
  USLUGI = 'uslugi',
  PORTFOLIO = 'portfolio',
  BLOG = 'articles',
  PRICES = 'prices',
}

export default AppRoute;
